module.exports = __webpack_public_path__ + "static/media/order_bg_2.c9e346b1.jpg";